import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useBrandProduct, productToBrand } from '../../contexts/BrandContext';
import { useTag } from '../../models/useTag';
import { useTemplate } from '../../models/useTemplate';

import TagDetailScreen from './TagDetailScreen';

/**
 * Wraps TagDetailScreen and sets product in BrandContext from tag/template
 * so the loading page and footer use the correct branding (striketip vs strikepay).
 */
export default function TagDetailScreenWithProduct(props) {
  const { tagId } = useParams();
  const baseTagId = tagId?.includes('---') ? tagId.split('---')[0] : tagId;
  const [, rawTag] = useTag(baseTagId);
  const [, template] = useTemplate(rawTag?.templateTagId || baseTagId);
  const { setProduct: setBrandProduct } = useBrandProduct();

  const product = rawTag?.product ?? template?.product;
  const brand = productToBrand(product);

  useEffect(() => {
    setBrandProduct(product ?? null);
    return () => setBrandProduct(null);
  }, [product, setBrandProduct]);

  return <TagDetailScreen {...props} brand={brand} />;
}
